import { BaseModel } from './base.model';

export interface GridDataInterface<T = any> {
  data: T[];
  pagination: PaginationModel;
}

export class PaginationModel extends BaseModel {
  currentPage = 1;
  perPage = 10;
  totalCount = 0;
  pageCount = 0;

  static fromApi(pagination: any): PaginationModel {
    const instance = new PaginationModel();

    if (!pagination) {
      return instance;
    }

    instance.currentPage = pagination.currentPage ?? 1;
    instance.perPage = pagination.perPage ?? 10;
    instance.totalCount = pagination.total ?? 0;
    instance.pageCount = pagination.totalPages ?? 0;

    return instance;
  }
}

